export default {
  attendant: 'Attendant',
  status: 'Online',
  paused: 'Paused',
  invisible: 'Invisible',
  total: 'Total',
};
